import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query"
import { coursesApi } from "../api/courses.api"

const COURSES_KEY = ["courses"] as const

export function useUploadDocument(courseId: string) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({
      file,
      onProgress,
    }: {
      file: File
      onProgress?: (pct: number) => void
    }) => coursesApi.uploadDocument(courseId, file, onProgress),
    onSuccess: () =>
      qc.invalidateQueries({ queryKey: [...COURSES_KEY, courseId] }),
  })
}

export function useDeleteDocument(courseId: string) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (docId: string) =>
      coursesApi.deleteDocument(courseId, docId),
    onSuccess: () =>
      qc.invalidateQueries({ queryKey: [...COURSES_KEY, courseId] }),
  })
}

export function useDocumentStatus(
  courseId: string,
  docId: string,
  options?: { enabled?: boolean }
) {
  return useQuery({
    queryKey: [...COURSES_KEY, courseId, "documents", docId, "status"],
    queryFn: () =>
      coursesApi.getDocumentStatus(courseId, docId).then((r) => r.data.data),
    enabled: (options?.enabled ?? true) && !!courseId && !!docId,
    refetchInterval: (query) => {
      const data = query.state.data
      if (!data) return false
      return data.status === "pending" || data.status === "processing"
        ? 3000
        : false
    },
  })
}
